export const config = {
  wordcount: {
    maxLength: 10
  },
  maxLength: 10,
  removeButtons: '',
  extraPlugins: ['mentions', 'emoji', 'colorbutton', 'font'],
  removePlugins: ['elementspath', 'dragdrop', 'basket'],
  fullPage: false,
  protectedSource: [/{{[\s\S]*?}}/g],
  resize_enabled: false,
  format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
  stylesSet: [
    { name: 'Marker Yellow', element: 'span', attributes: { 'style': 'background-color: yellow; padding: 2px 0;' } },
    { name: 'Marker Green', element: 'span', attributes: { 'style': 'background-color: green; padding: 2px 0;' } },
    { name: 'Subtitle', element: 'h3', attributes: { 'style': 'color:#aaaaaa; font-style:italic;' } },
    { name: 'Special container', element: 'div', attributes: { 'style': 'background:#eeeeee; border:1px solid #cccccc; padding:5px 10px;' } },
    { name: 'Big', element: 'big' },
    { name: 'Small', element: 'small' },
    { name: 'Typewriter', element: 'tt' },
    { name: 'Computer Code', element: 'code' },
    { name: 'Keyboard Phrase', element: 'kbd' },
    { name: 'Sample Text', element: 'samp' },
    { name: 'Variable', element: 'var' },
    { name: 'Deleted Text', element: 'del' },
    { name: 'Inserted Text', element: 'ins' },
    { name: 'Cited Work', element: 'cite' },
    { name: 'Inline Quotation', element: 'q' },
    { name: 'Language: RTL', element: 'p', attributes: { 'dir': 'rtl' } },
    { name: 'Language: LTR', element: 'p', attributes: { 'dir': 'ltr' } }
  ]
}
